<p-toast></p-toast>

<div *ngIf="fecInfo" class="grid mx-3">
  <div class="col-12 sm:col-6">
    <p><b>FEC Line Number:</b> {{ fecInfo.fecLineNumber || 'N/A' }}</p>
    <p><b>FEC Description:</b> {{ fecInfo.fecDescription || 'N/A' }}</p>
  </div>
  <div class="col-12 sm:col-6">
    <p><b>Is Memo:</b> {{ fecInfo.isMemo ? 'Yes' : 'No' }}</p>
    <p><b>Memo Text:</b> {{ fecInfo.memoText || 'N/A' }}</p>
  </div>
</div>

<!-- MODAL -->
<p-dialog 
  header="Edit FEC Compliance Info" 
  [(visible)]="isEditModalVisible" 
  [modal]="true" 
  [maximizable]="true" 
  draggable="false" 
  styleClass="p-dialog-static p-dialog-md fadeinright animation-duration-300">

  <div>
    <div ngClass="medium loader-wrapper" *ngIf="isEditDataLoading">
      <rc-loading-spinner></rc-loading-spinner>
    </div>

    <form [formGroup]="editForm" *ngIf="editForm && !isEditDataLoading">
      <p-card>
        <div class="formgrid grid">
          <div class="field col-12 md:col-6 lg:col-6">
            <label class="required">FEC Line Number</label>
            <p-dropdown formControlName="fecLineNumberId"
                        [options]="fecLineNumberOptions"
                        placeholder="Please Select"
                        optionLabel="text"
                        optionValue="value"
                        [ngClass]="{ 'ng-invalid': isInvalid('fecLineNumberId') }">
            </p-dropdown>
            <small class="p-error" *ngIf="isInvalid('fecLineNumberId')">FEC Line Number is required</small>
          </div>
          <div class="field col-12 md:col-6 lg:col-6">
            <label class="required">FEC Description</label>
            <textarea formControlName="fecDescription" rows="3" pInputTextarea
                      [ngClass]="{ 'ng-invalid': isInvalid('fecDescription') }"></textarea>
            <small class="p-error" *ngIf="isInvalid('fecDescription')">FEC Description is required</small>
          </div>
          <div class="field col-12 md:col-6 lg:col-6">
            <label>Is Memo</label>
            <p-inputSwitch formControlName="isMemo"></p-inputSwitch>
          </div>
          <div class="field col-12 md:col-6 lg:col-6">
            <label>Memo Text</label>
            <textarea formControlName="memoText" rows="3" pInputTextarea></textarea>
          </div>
        </div>
      </p-card>
      <div class="imported-dialog-footer">
        <p-button label="Cancel" type="button" [text]="true" (click)="onEditCancel()"></p-button>
        <p-button label="Save" severity="primary" type="button" (click)="onEditSubmit()" [disabled]="isReadOnlyMode"></p-button>
      </div>
    </form>
  </div>
</p-dialog>
